import React, { useEffect, useState } from "react";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import Master from "./Master";
import {
  collectionUpdate,
  collectionDistributionCategoriesList,
  collectionDetails,
} from "../../api/CollectionDistribution";
import { useLocation, useNavigate } from "react-router-dom";
import { batchDetailsWithStudents, batchList } from "../../api/Batch";
import { StaffList } from "../../api/Staff";
import {
  GetMarketingSchool,
  MarketingStudentList,
} from "../../api/MarketinService";
import { imgBaseUrl } from "../../api/api";
import { enquiryList } from "../../api/Enquiry";

export default function CollectionUpdate() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
  const [data, setData] = useState({});
  const [categories, setCategories] = useState([]);
  const [batches, setBatches] = useState([]);
  const [students, setStudents] = useState([]);
  const [staffs, setStaffs] = useState([]);
  const [enquiries, setEnquiries] = useState([]);
  const [marketingSource, setMarketingSource] = useState([]);
  const [marketingStudents, setMarketingStudents] = useState([]);

  const getData = async () => {
    setLoading(true);
    try {
      const response = await collectionDetails(id);
      if (response.data.status) {
        setData(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const getCategoryData = async () => {
    setLoading(true);
    try {
      const response = await collectionDistributionCategoriesList();
      if (response.data.status) {
        setCategories(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const getBatchData = async () => {
    setLoading(true);
    try {
      const response = await batchList();
      if (response.data.status) {
        setBatches(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const getStaffData = async () => {
    setLoading(true);
    try {
      const addUrl = `status=1`;
      const response = await StaffList(addUrl);
      if (response.data.status) {
        setStaffs(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const getEnquiryStudentData = async () => {
    setLoading(true);
    try {
      const addUrl = `limit=all`;
      const response = await enquiryList(addUrl);
      if (response.data.status) {
        setEnquiries(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const getBatchDataWithStudents = async () => {
    setLoading(true);
    try {
      let addUrl = `id=${data?.batch_id}`;
      const response = await batchDetailsWithStudents(addUrl);
      if (response.data.status) {
        setStudents(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const getMarketingSourceData = async () => {
    setLoading(true);
    try {
      const response = await GetMarketingSchool();
      if (response.data.status) {
        setMarketingSource(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const getMarketingStudentData = async () => {
    setLoading(true);
    try {
      let addUrl = `source_id=${data?.marketing_source_id}&limit=all`;
      const response = await MarketingStudentList(addUrl);
      if (response.data.status) {
        setMarketingStudents(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await collectionUpdate(formData);
      if (response?.data?.status) {
        e.target.reset();
        navigate("/collections");
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCategoryData();
    getData();
  }, []);

  useEffect(() => {
    if (data?.type === "student") {
      getBatchData();
    } else if (data?.type === "teacher") {
      getStaffData();
    } else if (data?.type === "enquiry") {
      getEnquiryStudentData();
    } else if (data?.type === "marketing") {
      getMarketingSourceData();
    }
  }, [data?.type]);

  useEffect(() => {
    if (data?.batch_id) {
      getBatchDataWithStudents();
    }
  }, [data?.batch_id]);

  useEffect(() => {
    if (data?.marketing_source_id) {
      getMarketingStudentData();
    }
  }, [data?.marketing_source_id]);

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />
                  <div className="col-md-10">
                    <div className="card">
                      <div className="card-body">
                        <h4 className="text-primary m-0">Collection Update</h4>
                        <hr />
                        <form action="" onSubmit={handleAdd}>
                          <div className="row g-3">
                            <div className="col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  name="category_id"
                                  id="category_id"
                                  required
                                  value={data?.category_id}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      category_id: e.target.value,
                                    })
                                  }
                                >
                                  <option value="" selected disabled>
                                    Select Category
                                  </option>
                                  {categories?.map((category, i) => (
                                    <option key={i} value={category?.id}>
                                      {category?.name}
                                    </option>
                                  ))}
                                </select>
                                <label htmlFor="category_id">Categories</label>
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  name="type"
                                  id="type"
                                  required
                                  value={data?.type}
                                  onChange={(e) =>
                                    setData({ ...data, type: e.target.value })
                                  }
                                >
                                  <option value="">Select Type</option>
                                  <option value="student">Student</option>
                                  <option value="teacher">Teacher</option>
                                  <option value="enquiry">Enquiry</option>
                                  <option value="marketing">Marketing</option>
                                </select>
                                <label htmlFor="type">Type</label>
                              </div>
                            </div>
                            {data?.type === "student" ? (
                              <>
                                <div className="col-sm-6">
                                  <div className="form-floating form-floating-outline">
                                    <select
                                      className="form-select"
                                      name="batch_id"
                                      id="batch_id"
                                      required
                                      value={data?.batch_id}
                                      onChange={(e) =>
                                        setData({
                                          ...data,
                                          batch_id: e.target.value,
                                        })
                                      }
                                    >
                                      <option value="">Select Batch</option>
                                      {batches?.map((batch, i) => (
                                        <option key={i} value={batch?.id}>
                                          {batch?.title}
                                        </option>
                                      ))}
                                    </select>
                                    <label htmlFor="batch_id">Batch</label>
                                  </div>
                                </div>
                                <div className="col-sm-6">
                                  <div className="form-floating form-floating-outline">
                                    <select
                                      className="form-select"
                                      name="user_id"
                                      id="user_id"
                                      required
                                      value={data?.student_id}
                                      onChange={(e) =>
                                        setData({
                                          ...data,
                                          student_id: e.target.value,
                                        })
                                      }
                                    >
                                      <option value="">Select Student</option>
                                      {students?.active_batch_students?.map(
                                        (student, i) => (
                                          <option
                                            key={i}
                                            value={student?.student_info?.id}
                                          >
                                            {student?.student_info?.name} (
                                            {
                                              student?.student_info
                                                ?.registration_no
                                            }
                                            )
                                          </option>
                                        )
                                      )}
                                    </select>
                                    <label htmlFor="user_id">Students</label>
                                  </div>
                                </div>
                              </>
                            ) : data?.type === "teacher" ? (
                              <div className="col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    className="form-select"
                                    name="user_id"
                                    id="user_id"
                                    required
                                    value={data?.staff_id}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        staff_id: e.target.value,
                                      })
                                    }
                                  >
                                    <option value="">Select Teacher</option>
                                    {staffs?.map((staff, i) => (
                                      <option key={i} value={staff?.id}>
                                        {staff?.name} ({staff?.registration_no})
                                      </option>
                                    ))}
                                  </select>
                                  <label htmlFor="user_id">Teachers</label>
                                </div>
                              </div>
                            ) : data?.type === "enquiry" ? (
                              <div className="col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    className="form-select"
                                    name="user_id"
                                    id="user_id"
                                    required
                                    value={data?.enquiry_id}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        enquiry_id: e.target.value,
                                      })
                                    }
                                  >
                                    <option value="">
                                      Select Enquiry Student
                                    </option>
                                    {enquiries?.map((enquiry, i) => (
                                      <option key={i} value={enquiry?.id}>
                                        {enquiry?.student_name} (
                                        {enquiry?.mobile})
                                      </option>
                                    ))}
                                  </select>
                                  <label htmlFor="user_id">
                                    Enquiry Student
                                  </label>
                                </div>
                              </div>
                            ) : (
                              data?.type === "marketing" && (
                                <>
                                  <div className="col-sm-6">
                                    <div className="form-floating form-floating-outline">
                                      <select
                                        className="form-select"
                                        name="marketing_source_id"
                                        id="marketing_source_id"
                                        required
                                        value={data?.marketing_source_id}
                                        onChange={(e) =>
                                          setData({
                                            ...data,
                                            marketing_source_id: e.target.value,
                                          })
                                        }
                                      >
                                        <option value="">
                                          Select Marketing Source
                                        </option>
                                        {marketingSource?.map((source, i) => (
                                          <option key={i} value={source?.id}>
                                            {source?.source_name}
                                          </option>
                                        ))}
                                      </select>
                                      <label htmlFor="marketing_source_id">
                                        Marketing Source
                                      </label>
                                    </div>
                                  </div>
                                  <div className="col-sm-6">
                                    <div className="form-floating form-floating-outline">
                                      <select
                                        className="form-select"
                                        name="user_id"
                                        id="user_id"
                                        required
                                        value={data?.marketing_student_id}
                                        onChange={(e) =>
                                          setData({
                                            ...data,
                                            marketing_student_id:
                                              e.target.value,
                                          })
                                        }
                                      >
                                        <option value="">
                                          Select Marketing Student
                                        </option>
                                        {marketingStudents?.map(
                                          (student, i) => (
                                            <option key={i} value={student?.id}>
                                              {student?.name} ({student?.mobile}
                                              )
                                            </option>
                                          )
                                        )}
                                      </select>
                                      <label htmlFor="user_id">
                                        Marketing Student
                                      </label>
                                    </div>
                                  </div>
                                </>
                              )
                            )}

                            <div className="col-sm-4">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="hidden"
                                  className="form-control"
                                  name="quantity"
                                  id="quantity"
                                  required
                                  value={data?.quantity}
                                />
                                <input
                                  type="file"
                                  className="form-control"
                                  name="img"
                                  id="img"
                                  required
                                />
                                <label htmlFor="img">File</label>
                              </div>
                            </div>
                            <div className="col-sm-2">
                              <img
                                src={imgBaseUrl + data?.img}
                                className="w-100"
                                alt=""
                              />
                            </div>
                            <div className="col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <textarea
                                  className="form-control input-uppercase"
                                  name="remark"
                                  id="remark"
                                  placeholder="Remark"
                                  value={data?.remark}
                                  onChange={(e) =>
                                    setData({ ...data, remark: e.target.value })
                                  }
                                />
                                <label htmlFor="remark">Remark</label>
                              </div>
                            </div>
                            <div className="col-12 text-end">
                              <button className="btn btn-label-primary">
                                Save
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
